export default [
    // { string_id: 'ads', name: 'Ad Units' },
    { string_id: 'advertisers', name: 'Advertisers' },
    // { string_id: 'adwords', name: 'AdWords' },
    { string_id: 'analytics', name: 'Reports' },
    { string_id: 'approvals', name: 'Approvals' },
    { string_id: 'campaigns', name: 'Campaigns' },
    { string_id: 'dashboard', name: 'Dashboard' },
    { string_id: 'offers', name: 'Offers' },
    { string_id: 'onboarding', name: 'Onboarding' },
    { string_id: 'partners', name: 'Publisher' },
    // { string_id: 'payouts', name: 'Payouts' },
    // { string_id: 'reports', name: 'Reports' },
    // { string_id: 'revenues', name: 'Revenues' },
    // { string_id: 'spending', name: 'Spending' },
    { string_id: 'splitter', name: 'Traffic Splitter' },
    // { string_id: 'tracking', name: 'Tracking' },
    { string_id: 'triggers', name: 'Triggers' },
    // { string_id: 'tsp', name: 'TSP' },
    // { string_id: 'usergroups', name: 'User Groups' },
    // { string_id: 'users', name: 'Users' },
    { string_id: 'vault', name: 'Creatives' },
];
